module.exports = __webpack_public_path__ + "static/assets/532ebcbd73bb17c82f76eb449d1a3709.png";